export var ReservationRoute;
(function (ReservationRoute) {
    ReservationRoute["REALTIME"] = "REALTIME";
    ReservationRoute["VENDOR_PHONE"] = "VENDOR_PHONE";
    ReservationRoute["VENDOR_INTERNET"] = "VENDOR_INTERNET";
    ReservationRoute["CUSTOMER_PHONE"] = "CUSTOMER_PHONE";
    ReservationRoute["CUSTOMER_INTERNET"] = "CUSTOMER_INTERNET";
})(ReservationRoute || (ReservationRoute = {}));
